import { AlertCircle } from 'lucide-react';

/** Inline form error banner (red alert box).
 *
 * Extracted verbatim from the store-management modal forms
 * (MarketRegularizationReasonsPage / StoreCategoriesPage / StoresPage), where this
 * exact markup was duplicated. Callers keep their own `{formError && (...)}` guard and
 * pass the message string in. */
export function FormErrorBanner({ message }: { message: string }) {
  return (
    <div className="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 p-3">
      <AlertCircle className="h-4 w-4 flex-shrink-0 text-red-500 mt-0.5" />
      <p className="text-sm text-red-600">{message}</p>
    </div>
  );
}
